import firebase from "../firebase.js";

const functions = firebase.app().functions("southamerica-east1");
// functions.useEmulator("localhost", 5001);

export default functions;
